/* GG Hobby — appends the POS-generated product rotation (window.GG_DROPS from drops-data.js)
   to the "New & Coming Soon" scroller, after the hand-placed feature cards. Skips anything that
   duplicates a static card's title; a card whose image fails to load removes itself. */
(function () {
  "use strict";
  var I18N = window.GG_I18N || {};
  function tr(s) { return I18N[s] || s; }
  var grid = document.getElementById("dropsGrid");
  if (!grid || !window.GG_DROPS || !window.GG_DROPS.length) return;
  var base = window.GG_DROPS_BASE || "assets/new/pos/";

  var existing = [];
  Array.prototype.forEach.call(grid.querySelectorAll("h3"), function (h) {
    existing.push(h.textContent.toLowerCase().trim());
  });

  window.GG_DROPS.forEach(function (d) {
    var t = d.n.toLowerCase();
    var dupe = existing.some(function (e) { return t.indexOf(e) !== -1 || e.indexOf(t) !== -1; });
    if (dupe) return;
    var a = document.createElement("article");
    a.className = "drop";
    var media = document.createElement("span");
    media.className = "drop__media";
    var badge = document.createElement("span");
    badge.className = "drop__badge";
    badge.textContent = tr("New");
    var img = document.createElement("img");
    img.src = base + d.img;
    img.alt = d.n;
    img.loading = "lazy";
    img.decoding = "async";
    img.onerror = function () { a.remove(); };
    media.appendChild(badge); media.appendChild(img);
    var h = document.createElement("h3"); h.textContent = d.n;
    var p = document.createElement("p"); p.textContent = d.t;
    a.appendChild(media); a.appendChild(h); a.appendChild(p);
    grid.appendChild(a);
  });
})();
